import axios from "axios";
import qs from "qs";

// api + "/finproinfo/" + id +"/findall"

import {api} from "@/plugins/util";

/**
 * 查询申请列表显示
 *
 */
export function applyList(pageNum, qyName, cxIdea) {
    return axios.get(api + "/xydaSelect/findall", {
        params: {
            pageNum,
            qyName,
            cxIdea
        }
    });
}

/**
 * 上传
 * @param {} file
 */
export function uoloadFile(formData) {
    return axios({
        url: api + "/xydaSelect/upload",
        method: "post",
        data: formData,
        headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
}

/**
 * 申请提交
 * @param {} qyname
 * @param {*} uscc
 * @param {*} fddbr
 * @param {*} sqtys
 * @param {*} cxresult
 * @param {*} imgUrl
 */
export function addApply({qyname, uscc, fddbr, cxresult, type}) {
    return axios.post(
        api + "/xydaSelect/add",
        qs.stringify({
            qyname,
            uscc,
            fddbr,
            cxresult,
            type
        })
    );
}
/**
 * 申请提交
 * @param {} qyname
 * @param {*} uscc
 * @param {*} fddbr
 * @param {*} sqtys
 * @param {*} cxresult
 * @param {*} imgUrl
 */
export function addApply2() {
    return axios.post(
        api + "/xydaSelect/add2",
        qs.stringify({

        })
    );
}
/**
 * 修改申请
 *
 */
export function updateApply(id, qyname, uscc, fddbr, cxresult, sqtys) {
    return axios.post(
        api + "/xydaSelect/update",
        qs.stringify({
            id,
            qyname,
            uscc,
            fddbr,
            cxresult,
            sqtys
        })
    );
}

/**
 * 融资企业管理列表显示
 *
 */
export function financingList(pageNum, State, qyName, proName, patterType,startTime,endTime,manager) {
    return axios.get(api + "/companyRz/findallByState", {
        params: {
            pageNum,
            State,
            qyName,
            proName,
            patterType,startTime,endTime,manager
        }
    });
}

/**
 * 受理申貸金額
 *
 */
export function updateState(id) {
    return axios.get(api + "/companyRz/update", {
        params: {
            id
        }
    });
}

/**
 * 拒贷
 *
 */
export function refuseState(sl, jdResult, proId) {
    return axios.get(api + "/companyRz/addJd", {
        params: {
            sl,
            jdResult,
            proId
        }
    });
}

/**
 * 授信
 *
 */
export function loanState(sl, fkje, /*hraccount,*/ fkl, fkqx, proId) {
    return axios.get(api + "/companyRz/addFk", {
        params: {
            sl,
            fkje,
            // hraccount,
            fkl,
            fkqx,
            proId
        }
    });
}

/**
 * 我的融资管理
 *
 */

export function myFinancing(pageNum, proName, serveBank,timeStart,timeEnd) {
    return axios.get(api + "/finance/findall", {
        params: {
            pageNum,
            proName,
            serveBank,timeStart,timeEnd
        }
    });
}

/**
 * 下拉
 *
 */

export function mySelect() {
    return axios.get(api + "/finance/findallPro", {
        params: {}
    });
}
export function getRecommended(amount,deadline,rate) {
    return axios.get(api + "/finance/getRecommended", {
        params: {amount,deadline,rate}
    });
}
export function mySelectResult() {
    return axios.get(api + "/xydaSelect/findallResult", {
        params: {}
    });
}

/**
 * 下拉框弹出信息
 *
 */

export function mySelectmes(id) {
    return axios.get(api + "/finance/findallById", {
        params: {
            id
        }
    });
}

/**
 * 查看是否报价
 */
export function findOne(Fid) {
    return axios.get(api + "/offer/findOne", {
        params: {
            Fid
        }
    });
}

/**
 * 查看银行报价
 */
export function offerList(Fid) {
    return axios.get(api + "/offer/list", {
        params: {
            Fid
        }
    });
}

/**
 * 新增报价
 */
export function addOffer({Fid, fkje, fkl, guarantee, descriptionOfOtherConditions, productName, productId}) {
    return axios.post(
        api + "/offer/add",
        qs.stringify({
            Fid,
            fkje,
            fkl,
            guarantee,
            descriptionOfOtherConditions,
            productName, productId
        })
    );
}

/**
 * 选择报价申请贷款
 */
export function getOffer({fid, yid, yname, productName, userId, productId}, companyName) {
    return axios.post(
        api + "/offer/update",
        qs.stringify({
            fid,
            yid,
            yname, userId, productName, companyName, productId
        })
    );
}

/**
 * 我要融资
 *
 */
export function addFinancing(
    {
        status,
        companyName,
        socialCreditUnicode,
        proid,
        commitAmout,
        deadline,
        frdb,
        agree,
        sqtys,
        companyId,
        contact,
        contactMobile,
        userId,
        code,
        address,
        contactIdcard,
        interestRate,
        area,
        taxAmountOfLastYear,
        profitOrLossStatus,
        businessIncome,
        taxGrade,
        isCollateral,
        bankOfDeposit,
        currentLoanBalance,
        loanArrival,
        previousLendingInstitutions,
        industry,
        isFirstUser,yt,financingRequirementsCode,operatorCode
    }
    // data
) {
    commitAmout = parseFloat(commitAmout.replace(/,/g, ""));
    return axios.post(api + "/finance/add", qs.stringify({
            status,
            companyName,
            socialCreditUnicode,
            proid,
            commitAmout,
            deadline,
            frdb,
            agree,
            sqtys,
            companyId,
            contact,
            contactMobile,
            userId,
            code,
            address,
            contactIdcard,
            interestRate,
            area,
            taxAmountOfLastYear,
            profitOrLossStatus,
            businessIncome,
            taxGrade,
            isCollateral,
            bankOfDeposit,
            currentLoanBalance,
            loanArrival,
            previousLendingInstitutions,
            industry,
            isFirstUser,yt,financingRequirementsCode,operatorCode
        })
        // data: data
    );
}

/**
 * 上传
 * @param {} file
 */
export function uoloadFilesq(formData) {
    return axios({
        url: api + "/finance/uploadSq",
        method: "post",
        data: formData,
        headers: {"Content-Type": "application/x-www-form-urlencoded"}
    });
}

/**
 * 信用档案列表显示
 *
 */
export function recordList(pageNum, finenceId) {
    return axios.get(api + "/companyRz/findallByFinenceId", {
        params: {
            pageNum,
            finenceId
        }
    });
}

/**
 * 新增查询
 *
 */
export function newApply(cxresult, finenceid, sqtys, loginid, companyId,orderId) {
    return axios.post(
        api + "/companyRz/addXydaSelect",
        qs.stringify({
            cxresult,
            finenceid,
            sqtys,
            loginid,
            companyId,
            orderId,
        })
    );
}

/**
 * 新增查询
 *
 */
export function getFzjg(yxdwId, area) {
    return axios.post(
        api + "/yxdwUser/getFzjg",
        qs.stringify({
            yxdwId, area
        })
    );
}

//数字转化为中文       --start
let chineseNumb = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];

/**
 * 辅助函数，用于把四位的字符串转成中文
 * @param str 输入的字符串
 * @param isBegin 是否是开头部分，开头部分和中间部分读法都不同
 * @returns {string} 四位字符串
 */
export function turnToChinese(str, isBegin) {
    let result = "";
    let numb = parseInt(str);
    if (numb === 0) {
        result = isBegin ? "" : "零";
    } else if (numb > 0 && numb < 10) {
        //一位数
        let g = chineseNumb[numb];
        result = result + (isBegin ? "" + g : "零" + g);
    } else if (numb >= 10 && numb < 100) {
        //两位数
        let s = chineseNumb[parseInt(numb / 10)] + "拾";
        let g = (numb % 10 === 0 ? "" : chineseNumb[numb % 10]);
        result = result + (isBegin ? "" + s + g : "零" + s + g);
    } else if (numb >= 100 && numb < 1000) {
        //三位数
        let b = chineseNumb[parseInt(numb / 100)] + "佰";
        let s = (parseInt(numb % 100 / 10) === 0 ? "零" : chineseNumb[parseInt(numb % 100 / 10)] + "拾");
        let g = (numb % 10 === 0 ? "" : chineseNumb[numb % 10]);
        result = result + (isBegin ? "" + b + s + g : "零" + b + s + g);
    } else {
        //四位数
        let q = chineseNumb[parseInt(numb / 1000)] + "仟";
        let b = (parseInt(numb % 1000 / 100) === 0 ? "零" : chineseNumb[parseInt(numb % 1000 / 100)] + "佰");
        let s = (parseInt(numb % 100 / 10) === 0 ? "零" : chineseNumb[parseInt(numb % 100 / 10)] + "拾");
        let g = (numb % 10 === 0 ? "" : chineseNumb[numb % 10]);
        result = result + q + b + s + g;
    }
    return result.replace(/零零/, "零");
}

/**
 * 万元转汉字显示
 * @param num
 * @returns {string}
 */
export function numberToChines(num) {
    //结果
    let result = "";
    //拆分成整数和小数部分
    let str1 = num.split(".");
    //整数
    let c = str1[0].replaceAll(",", "");
    console.log(c)
    if (typeof (c) != "string") {
        c = c.toString();
    }
    //整数部分
    if (c.split(",")[0].length >= 0 && c.split(",")[0].length < 4) {
        result += turnToChinese(c, true) + "萬";
    } else if (c.split(",")[0].length >= 4 && c.length < 5) {
        result += turnToChinese(c, false) + "仟萬";
    } else if (c.split(",")[0].length == 5) {
        result += turnToChinese(c.substring(0, 1), false).substring(1, turnToChinese(c.substring(0, 1), false).length) + "亿" + turnToChinese(c.substring(1, c.length)) + "萬";
    }

    //小数部分
    if (str1.length === 1) {
        return result + "圆整";
    } else {
        let fp = (str1[1] + "0").substring(0, 2);
        let floatPart = parseInt(fp);
        if (floatPart === 0) {
            return result + "圆整";
        }
        let j = parseInt(floatPart / 10);
        result += j !== 0 ? chineseNumb[j] + "仟" : "";
        let fen = floatPart % 10;
        result += fen !== 0 ? chineseNumb[fen] + "佰" : "";
        return result + "圆整";
    }
}


/**
 * 转换接口 传入字符串直接调用
 * @param str 需要传入的字符串
 * @returns {string} 返回的也是字符串
 */
export function priceToChinese(str) {
    //拆分成两部分，整数部分和小数部分
    let numb_array = str.split('.');
    //返回的结果
    let result = "";
    //获取到整数部分
    let num = numb_array[0].split(",");
    let intPart = "";
    for (let o = 0; o < num.length; o++) {
        intPart += num[o];
    }
    //整数部分长度
    let intPartLength = intPart.length;
    // console.log("intPartLength"+intPartLength);
    if (intPartLength > 8) {
        //亿的部分 n2亿
        let n2 = intPart.substring(intPartLength - 12, intPartLength - 8);
        if (parseInt(n2) !== 0) {
            result = result + turnToChinese(n2, true) + "亿";
        }
        //万的部分 n1万
        let n1 = intPart.substring(intPartLength - 8, intPartLength - 4);
        if (parseInt(n1) !== 0) {
            result = result + turnToChinese(n1, false) + "万";
        }
        //少于一万的部分 n0
        let n0 = intPart.substring(intPartLength - 4, intPartLength);
        result = result + turnToChinese(n0, false);

        //当0作为结尾时不需要显示这个“零”
        if (result.endsWith("零", result.length)) {
            result = result.substring(0, result.length - 1);
        }
    } else if (intPartLength > 4) {
        //万的部分 n1万
        let n1 = intPart.substring(intPartLength - 8, intPartLength - 4);
        if (parseInt(n1) !== 0) {
            result = result + turnToChinese(n1, true) + "万";
        }
        //少于一万的部分 n0
        let n0 = intPart.substring(intPartLength - 4, intPartLength);
        result = result + turnToChinese(n0, false);
        //当0作为结尾时不需要显示这个“零”
        if (result.endsWith("零", result.length)) {
            result = result.substring(0, result.length - 1);
        }
    } else if (intPartLength <= 4) {
        //少于一万的部分 n0
        let n0 = intPart.substring(intPartLength - 4, intPartLength);
        result = result + turnToChinese(n0, true);
        if (result.endsWith("零", result.length)) {
            result = result.substring(0, result.length - 1);
        }
    }
    //如果以小数点分割后 只有整数部分||小数部分为0，拼接上 “圆整”，否则还应加上“角分”单位
    if (numb_array.length === 1) {
        return result + "圆整";
    } else {
        let fp = (numb_array[1] + "0").substring(0, 2);
        let floatPart = parseInt(fp);
        if (floatPart === 0) {
            return result + "圆整";
        }
        result = result + "圆";
        let j = parseInt(floatPart / 10);
        result += chineseNumb[j] + "角";
        let fen = floatPart % 10;
        result += chineseNumb[fen] + "分";
        return result;
    }
}

//数字转化为中文       --end
export function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
};

function padLeftZero(str) {
    return ('00' + str).substr(str.length);
};

export function priceToChinese1(str) {
    //拆分成两部分，整数部分和小数部分
    let numb_array = str.split('.');
    //返回的结果
    let result = "";
    let str1 = "";
    //获取到整数部分
    let intPart = numb_array[0];

    //小数部分长度
    console.log(numb_array)
    console.log(numb_array.length)
    if (numb_array.length === 1) {

        result = intPart + ".0000"
    } else {
        let intPart1 = numb_array[1];
        let intPartLength1 = intPart1.length;
        console.log(intPartLength1)
        if (intPartLength1 > 4) {
            str1 = intPart1.substr(0, 4);
            result = intPart + "." + str1
        } else if (intPartLength1 == 1) {
            str1 = intPart1.substr(0, 1);
            result = intPart + "." + str1 + "000"
        } else if (intPartLength1 == 2) {
            str1 = intPart1.substr(0, 2);
            result = intPart + "." + str1 + "00"
        } else if (intPartLength1 == 3) {
            str1 = intPart1.substr(0, 3);
            result = intPart + "." + str1 + "0"
        } else if (intPartLength1 == 4) {
            str1 = intPart1.substr(0, 4);
            result = intPart + "." + str1
        }
    }


    return result;
}

//查询所有担保公司
export function getAllGuarantee() {
    return axios.get(api + "/companyRz/getAllGuarantee")
}

//添加放款记录
export function addLoanRecord(data) {
    return axios.post(
        api + "/companyRz/addLoanRecord",
        data
    );
}

//添加还款记录
export function addRepaymentRecord(data) {
    return axios.post(
        api + "/companyRz/addRepaymentRecord",
        data
    );
}

//查询基准利率
export function getJzll() {
    return axios.post(
        api + "/companyRz/getJzll"
    );
}

//查询放款总金额
export function getTotalLoanAmount(companyId) {
    return axios.get(api + "/companyRz/getTotalLoanAmount", {
        params: {
            companyId
        }
    })
}

//查询放款列表
export function getLoanList(companyId, current, pageSize) {
    return axios.get(api + "/companyRz/getLoanList", {
        params: {
            companyId,
            current,
            pageSize
        }
    })
}

//查询还款列表
export function getRepaymentList(loanId, current, pageSize) {
    return axios.get(api + "/companyRz/getRepaymentList", {
        params: {
            loanId,
            current,
            pageSize
        }
    })
}

//查询关联企业信息
export function getAffiliatedCompanyList() {
    return axios.get(api + "/affiliatedCompany/getAffiliatedCompanyList", {})
}

//查询档案
export function myReport(uscc, qyName) {
    return axios.post(api + "/affiliatedCompany/myReport", qs.stringify({
        uscc,
        qyName
    }));
}
/**
 * 查询预警列表
 *
 */
export function warningList(pageNum, uscc) {
    return axios.get(api + "/warning/findall", {
        params: {
            pageNum,
            uscc
        }
    });
}
export function financingRequirementsCode(
    {
        companyName,
        socialCreditUnicode,
        contactMobile
    }
    // data
) {
    return axios.get(api + "/finance/financingRequirementsCode", {
        params: {
            companyName,
            socialCreditUnicode,
            contactMobile
        }
        // data: data
    });
}
